import type { ServiceResourceNote } from "./types";

export function isServiceResourceNoteActive(note: ServiceResourceNote, today = todayIsoDate()): boolean {
  if (note.dismissed_at) return false;
  if (!note.expires_on) return true;
  return note.expires_on >= today;
}

function todayIsoDate(): string {
  return new Date().toISOString().slice(0, 10);
}
